// extracted by mini-css-extract-plugin
export var active = "index-module--active--JNiFW";
export var newsTab = "index-module--newsTab--xerOk";
export var tab = "index-module--tab--2zCri";